import React, { FC } from 'react';
import { DateCalendar, DateCalendarProps } from '@mui/x-date-pickers/DateCalendar';
import { BpDesignSystem } from '../../types';
import { Dayjs } from 'dayjs';
import {
  PickersDay as MuiPickersDay,
  type PickersDayProps as MuiPickersDayProps
} from '@mui/x-date-pickers/PickersDay';
import { FormHelperText, FormLabel, FormHelperTextProps, FormLabelProps } from '../Form/index';
import { Box } from '../Box/Box';

export type CalendarProps = BpDesignSystem.InputProps<
  // onMonthChange doesn't work well with controlled components, so we omit it here. It prevents switching months when a value is set.
  Omit<DateCalendarProps<Dayjs>, 'onMonthChange'> & {
    slotProps?: {
      formLabel?: Partial<FormLabelProps>;
      formHelperText?: Partial<FormHelperTextProps>;
    };
  }
>;

export const Calendar: FC<CalendarProps> = ({
  dataTest,
  label,
  error,
  errorText,
  helperText,
  required,
  disabled,
  sx,
  style,
  className,
  ...rest
}) => {
  return (
    <Box sx={sx} style={style} className={className} data-test={`${dataTest}-wrapper`}>
      <FormLabel required={required} dataTest={`${dataTest}-label`} error={error} {...rest?.slotProps?.formLabel}>
        {label}
      </FormLabel>
      <Box display="inline-block">
        <DateCalendar data-test={dataTest} disabled={disabled} {...rest} />
      </Box>
      <FormHelperText
        error={error}
        helperText={helperText}
        errorText={errorText}
        {...rest?.slotProps?.formHelperText}
      />
    </Box>
  );
};

export type PickersDayProps = BpDesignSystem.PropsWithChildren<MuiPickersDayProps<Dayjs> & {}>;
export const PickersDay: FC<PickersDayProps> = ({ dataTest, ...rest }) => (
  <MuiPickersDay data-test={dataTest} {...rest} />
);
